import { CANONICAL_ROUTES } from './site';

/**
 * Old site and alternate paths that should permanently move to a current page.
 * Keys must be lowercase, without a trailing slash or .php/.html suffix.
 */
export const LEGACY_REDIRECTS = {
  '/home': '/',
  '/news-releases': '/news',
  '/news-release': '/news',
  '/press': '/news',
  '/press-releases': '/news',
  '/press-release': '/news',
  '/media': '/news',
  '/investor_relations': '/investors',
  '/investor-relations': '/investors',
  '/ir': '/investors',
  '/mine-centre-experimental': '/project/mine-centre',
  '/mine-centre': '/project/mine-centre',
  '/mine_centre': '/project/mine-centre',
  '/minecentre': '/project/mine-centre',
  '/location_overview': '/project/mine-centre',
  '/location-overview': '/project/mine-centre',
  '/quartz-mountain': '/project/quartz-mountain',
  '/quartz_mountain': '/project/quartz-mountain',
  '/about': '/company',
  '/about-us': '/company',
  '/about_us': '/company',
  '/team': '/company',
  '/management': '/company',
  '/contact-us': '/contact',
  '/contact_us': '/contact',
  '/gallery': '/media-centre',
  '/media-gallery': '/media-centre',
  '/mediacentre': '/media-centre',
};

export function normalizePath(pathname) {
  if (!pathname) return '/';

  let path = String(pathname).split('?')[0].split('#')[0];
  try {
    path = decodeURIComponent(path);
  } catch {
    // keep the raw path if it is not valid URI encoding
  }

  path = path.replace(/\/+/g, '/');
  if (path.length > 1) {
    path = path.replace(/\/+$/, '');
  }
  path = path.toLowerCase();

  if (path.endsWith('.php')) {
    path = path.slice(0, -4) || '/';
  } else if (path.endsWith('.html') && path !== '/') {
    path = path.slice(0, -5) || '/';
  } else if (path.endsWith('.htm') && path !== '/') {
    path = path.slice(0, -4) || '/';
  }

  if (path === '/index') return '/';
  return path || '/';
}

function isKnownPath(path) {
  if (CANONICAL_ROUTES.has(path)) return true;
  return /^\/news\/[^/]+$/.test(path) || /^\/media-centre\/[^/]+$/.test(path);
}

/**
 * Returns a current-site path to redirect to, or null if the URL should 404.
 */
export function resolvePathRedirect(pathname) {
  const path = normalizePath(pathname);
  if (LEGACY_REDIRECTS[path]) {
    return LEGACY_REDIRECTS[path];
  }

  const raw = String(pathname || '/').split('?')[0].split('#')[0];
  if (path !== raw && isKnownPath(path)) {
    return path;
  }

  return null;
}
